var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-page" },
    [
      _c(
        "b-container",
        [
          _c("h1", [_vm._v("Preise")]),
          _vm._v(" "),
          _c("PriceTable"),
          _vm._v(" "),
          _c("h2", { staticClass: "mb-1" }, [_vm._v("So funktioniert's:")]),
          _vm._v(" "),
          _c("div", [
            _vm._v("Schneller und einfacher zum passenden Mitarbeiter.")
          ]),
          _vm._v(" "),
          _c("HowItWorks", { staticClass: "mt-4" }),
          _vm._v(" "),
          _c("CustomerBenefits", { staticClass: "mt-4" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4 text-center" },
            [
              _c("Button", {
                attrs: {
                  icon: "caret-right",
                  text: "Passende Mitarbeiter finden!",
                  href: "/kunde/eintragung"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }